// https://stackoverflow.com/a/326076/8795000
const isInsideIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export default isInsideIframe;
